import { Component, ElementRef, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { AppComponent } from 'src/app/app.component';
import { UtilsService } from 'src/app/services/utils.service';
import { DateTime } from 'luxon';
import { GolfService } from 'src/app/services/golf.service';
import { AppSettings } from 'src/app/app.settings';
import { RecaptchaComponent } from 'ng-recaptcha';
import { GetPartenzaReq, GetPartenzeReq, Partenza, Percorso } from 'src/app/models/Percorso';
import { crossMsg, CrossService, drOption, MyReq, OptionId } from '@robisoft/cross-library';
import { CrossCpService } from 'src/app/cross-utils/services/cross-cp.service';
import { DatePickerComponent } from 'src/app/cross-utils/date-picker/date-picker.component';
import { SendFormReq } from 'src/app/models/SendForm';
import { PrivacyComponent } from 'src/app/cross-utils/privacy/privacy.component';
import { Subscription } from 'rxjs';
import { Biglietto, Partecipante } from 'src/app/models/Biglietto';
import { AccessorioInfo } from 'src/app/models/Accessorio';


@Component({
  selector: 'app-prenota-teetime',
  templateUrl: './prenota-teetime.component.html',
  styleUrls: ['./prenota-teetime.component.scss'],
  encapsulation: ViewEncapsulation.Emulated
})
export class PrenotaTeetimeComponent implements OnInit, OnDestroy {

  cart: Biglietto[];

  partenze: Partenza[];
  percorso: number;
  percorsoDescr: string;
  percorsi: Percorso[];

  giorno: DateTime;
  today: DateTime;
  currData: DateTime;
  currWeek: DateTime[];
  currDayActiveIndex: number; //0-6

  isSocio: boolean;
  richiestaInviata: boolean;
  error: string;
  isLoading: boolean;
  visualizzaNomi: boolean;

  dispCarrelli: number;
  dispCarrelliEl: number;
  dispGolfcar: number;
  dispSacche: number;

  App: string;

  prenotaNome: string;
  prenotaEmail: string;
  prenotaMobile: string;
  prenotaMsg: string;
  prenotaData: string;
  prenotaOra: string;
  prenotaPosti: string;
  privacy: boolean;
  errorMessage: string;

  // per il captcha
  captcha: string;
  @ViewChild('recaptcha') captchaElem: RecaptchaComponent;
  sub: Subscription;
  firstRun: boolean;

  constructor(public app: AppComponent,
    public sanitizer: DomSanitizer,
    private golfService: GolfService,
    private cpService: CrossCpService,
    private crossService: CrossService,
    private dialog: MatDialog,
    public utils: UtilsService,
  ) {
    this.cart = [];
    this.partenze = [];
    this.percorso = 0;
    this.percorsoDescr = '';
    this.percorsi = [];
    this.isSocio = false;
    this.richiestaInviata = false;
    this.error = '';
    this.isLoading = false;
    this.visualizzaNomi = false;
    this.dispCarrelli = 0;
    this.dispCarrelliEl = 0;
    this.dispGolfcar = 0;
    this.dispSacche = 0;
    this.App = AppSettings.App;

    this.prenotaNome = '';
    this.prenotaEmail = '';
    this.prenotaMobile = '';
    this.prenotaMsg = '';
    this.prenotaData = '';
    this.prenotaOra = '';
    this.prenotaPosti = '';
    this.privacy = false;
    this.errorMessage = '';

    this.captcha = '';
    this.sub = new Subscription();
    this.firstRun = false;
  }

  ngOnInit(): void {

    this.sub = this.app.initialized.subscribe(async (init) => {
      if (init && !this.firstRun) {
        await this.init();
      }
    });

  }

  ngOnDestroy() {
  }

  async init() {
    if (!this.app.store || !this.app.mytoken)
      return;
    this.firstRun = true;

    const jsonCart = localStorage.getItem(this.app.store + '-cart');
    if (jsonCart && jsonCart.indexOf('[') >= 0) {
      this.cart = JSON.parse(jsonCart);
      this.cart.forEach((bi) => {
        /* if (bi.DataBiglietto)
          bi.DataBiglietto = DateTime.fromISO(bi.DataBiglietto); */
      });
    }
    if (DateTime.local().weekday == 7)
      this.giorno = DateTime.local().plus({ days: 1 });
    else if (DateTime.local().weekday == 6)
      this.giorno = DateTime.local().plus({ days: 2 });
    else
      this.giorno = DateTime.local();

    this.today = DateTime.local();

    this.buildDateCarousel(this.giorno);

    this.refreshOrari();
  }

  resolved(captchaResponse: string) {
    this.captcha = captchaResponse;
    this.checkForm();
  }

  async refreshOrari(): Promise<void> {
    let req = new MyReq();
    req.store = this.app.store;
    req.myToken = this.app.mytoken;

    const resp = await this.golfService.GetPercorsi(req);
    if (resp.error === '') {
      this.percorsi = [];
      if (resp.percorsi)
        resp.percorsi.forEach(per => {
          this.percorsi.push(per as Percorso);
        });

      this.isSocio = resp.isSocio;
      if (this.percorsi && this.percorsi.length > 0) {
        // this.percorso = resp.percorsi[0].id;
        // this.percorsoDescr = resp.percorsi[0].descr;
        // await this.onVisualizza();
      }
    }
  }

  async onVisualizza() {
    if (this.percorso === 0) {
      this.app.onMessage.emit(new crossMsg('ShowError', {
        message: 'Devi selezionare un percorso',
      }));
    } else {
      let req = new GetPartenzeReq();
      req.data = this.giorno.toString();
      req.myToken = this.app.mytoken;
      req.store = this.app.store;
      req.percorso = this.percorso;

      const resp = await this.golfService.GetPartenze(req);
      if (resp.error === '' && resp.partenze !== null && resp.partenze.length > 0) {
        this.partenze = resp.partenze;
        this.dispCarrelli = resp.dispCarrelli;
        this.dispCarrelliEl = resp.dispCarrelliEl;
        this.dispGolfcar = resp.dispGolfcar;
        this.dispSacche = resp.dispSacche;
      } else {
        this.partenze = [];
        this.dispCarrelli = 0;
        this.dispCarrelliEl = 0;
        this.dispGolfcar = 0;
        this.dispSacche = 0;
      }
      this.error = resp.error;
      this.isSocio = resp.isSocio;
    }
  }

  SelectPercorso() {
    if (this.percorsi && this.percorso) {
      let descr = this.percorsi.find(p => p.id === this.percorso)?.descr
      this.percorsoDescr = descr ? descr : '';
    }
    else
      this.percorsoDescr = '';
    this.onVisualizza();
  }

  buildDateCarousel(startDay: DateTime) {
    this.currData = startDay;
    this.currWeek = [];
    this.currWeek.push(startDay);
    this.currWeek.push(startDay.plus({ days: 1 }));
    this.currWeek.push(startDay.plus({ days: 2 }));
    this.currDayActiveIndex = 0;
  }

  isDayDisabled(index: number): string {
    if (this.currWeek[index].startOf("day") > this.getDay().startOf("day")) {
      return ' disabled';
    }
    else
      return '';
  }

  placeholderDatePicker(field: string) {
    let weekDay = '';
    switch (field) {
      case 'DaData':
        weekDay = this.utils.getShortWeekDay(this.giorno.weekday);
        weekDay += ' ' + this.utils.formatLocaleDate(this.giorno);
    }
    return weekDay;
  }

  setDataFromCarousel(index: number) {
    if (this.isDayDisabled(index) == '') {
      this.currDayActiveIndex = index;
      this.giorno = this.currWeek[index];
      this.today = DateTime.local();
      this.refreshOrari();
      this.onVisualizza();
      localStorage.setItem(this.app.store + '-ombrelloniDate', JSON.stringify(this.giorno));
    }
  }

  openDatePicker(evt: MouseEvent, field: string) {
    const target = new ElementRef(evt.currentTarget);
    let date: DateTime | null = null;
    switch (field) {
      case 'DaData':
        date = this.giorno;
        break;
      case 'AData':
        break;
    }
    const dialogRef = this.dialog.open(DatePickerComponent, {
      data: {
        trigger: target,
        date: date,
        escludiGiorni: [],
        escludiDate: this.getDatesToExclude(),
        lang: this.app.currlang,
        giorno: this.giorno,
        aData: this.getDay()
      },
      panelClass: 'datepicker-modalbox',
      /* position: {
        top: '-100px',
        left: '-100px'
      } */
    });
    dialogRef.afterClosed().subscribe(async (result) => {
      if (result) {
        switch (field) {
          case 'DaData':
            this.giorno = result;
            this.today = DateTime.local();
            this.buildDateCarousel(this.giorno);
            this.refreshOrari();
            this.onVisualizza();
            localStorage.setItem(this.app.store + '-ombrelloniDate', JSON.stringify(this.giorno));
            break;
          case 'AData':
            break;
        }
        await this.changeDate();
      }
    });
  }

  getDay(): DateTime {
    const day = DateTime.local().plus({ days: 1 });  // this.configApp.BloccaPrenotaOmbGg
    return day;
  }

  getDatesToExclude(): DateTime[] {
    /* if (this.configApp.BloccoSabDom) {
      if (DateTime.local().weekday == 6) {
        return [DateTime.local(), DateTime.local().plus({ days: 1 })];
      }
      else if (DateTime.local().weekday == 7) {
        return [DateTime.local()];
      }
      else
        return [];
    } */
    return [];
  }

  avanti() {
    if (this.isAvantiDisabled() == '') {
      this.giorno = this.currWeek[0].plus({ days: 3 });
      this.today = DateTime.local();
      this.buildDateCarousel(this.giorno);
      this.refreshOrari();
      localStorage.setItem(this.app.store + '-ombrelloniDate', JSON.stringify(this.giorno));
    }
  }

  isAvantiDisabled(): string {
    if (this.currWeek[0].plus({ days: 3 }).startOf("day") > this.getDay().startOf("day")) {
      return ' disabled';
    }
    else
      return '';
  }

  indietro() {
    this.giorno = this.currWeek[0].minus({ days: 3 });

    if (DateTime.local().weekday == 7 && this.giorno < DateTime.local().plus({ days: 1 }))
      this.giorno = DateTime.local().plus({ days: 1 });
    else if (DateTime.local().weekday == 6 && this.giorno < DateTime.local().plus({ days: 2 }))
      this.giorno = DateTime.local().plus({ days: 2 });
    else if (this.giorno < DateTime.local())
      this.giorno = DateTime.local();

    this.today = DateTime.local();

    this.buildDateCarousel(this.giorno);
    this.refreshOrari();
    localStorage.setItem(this.app.store + '-ombrelloniDate', JSON.stringify(this.giorno));
  }

  isIndietroVisible() {
    if (DateTime.local().weekday == 7)
      return (this.currWeek[0] > DateTime.local().plus({ days: 1 }));
    else if (DateTime.local().weekday == 6)
      return (this.currWeek[0] > DateTime.local().plus({ days: 2 }));
    else
      return (this.currWeek[0] > DateTime.local());
  }

  async changeDate() {

  }


  onInviaRichiesta() {

  }


  async Prenota(p: Partenza) {
    if (this.app.curruser.userId === 0 && p.Prezzo <= 0) {
      this.gotoLogin();
      return;
    }
    else if (!this.isSocio && p.Prezzo <= 0) {
      this.gotoSocioPage();
      return;
    }

    let req = new GetPartenzaReq();
    req.store = this.app.store;
    req.myToken = this.app.mytoken;
    req.partenzaId = p.IDPartenza;

    const resp = await this.golfService.GetPartenza(req);
    if (resp.error === '' && resp.partenza !== null) {

      let biglietto = new Biglietto();
      biglietto.Mode = 'Acquista';
      /* if (this.config.pagInLoco) {
        biglietto.Prenotabile = true;
      } */
      biglietto.ParentID = -10;
      biglietto.Tipo = 'Teetime';
      biglietto.Qta = 1;
      biglietto.Prezzo = resp.partenza.Prezzo;
      biglietto.PrezzoScontato = resp.partenza.Prezzo;
      biglietto.PrezzoListino = resp.partenza.Prezzo;
      biglietto.ScontoPerc = 0;
      // biglietto.Servizio = this.configApp.ServizioOmbOnline;
      biglietto.Separa = false;
      biglietto.Disp = p.Disp;
      biglietto.DataBiglietto = this.giorno;
      biglietto.OraBiglietto = this.utils.To2digit(p.Ore) + ':' + this.utils.To2digit(p.Minuti);
      biglietto.Categoria = this.percorsoDescr;
      biglietto.Evento = this.percorso.toString();
      // biglietto.PrenotaEntroLe = this.configApp.PrenotaOmbEntroLe;
      // biglietto.SpostaEntroLe = this.configApp.SpostaOmbEntroLe;  // ?? da vedere
      // biglietto.Note = this.order.priceType;
      biglietto.Descrizione = 'Prenotazione partenza delle ' + this.utils.To2digit(p.Ore) + ':' + this.utils.To2digit(p.Minuti) + ' per il giorno ' + this.giorno.toFormat('dd/MM/yyyy');
      biglietto.Descrizione = '<br />Percorso ' + this.percorsoDescr;
      biglietto.CampiObbPartec = 'name,surname';
      biglietto.CampiFacPartec = 'hcp';
      // biglietto.AliqIVA = this.configApp.IvaOmbrelloni;
      // TODO biglietto.ADataBiglietto = this.aData;
      biglietto.AccessoriInfo = [];
      let acc3 = new AccessorioInfo();
      acc3.descrIt = 'Golfcar';
      acc3.prezzo = resp.partenza.PrezzoGolfcar;
      acc3.qta = 0;
      acc3.type = 2;
      acc3.isObb = false;
      acc3.max = 1;
      acc3.index = 1;
      biglietto.AccessoriInfo.push(acc3);
      let acc1 = new AccessorioInfo();
      acc1.descrIt = 'Carrello';
      acc1.prezzo = resp.partenza.PrezzoCarrello;
      acc1.qta = 0;
      acc1.type = 2;
      acc1.isObb = false;
      acc1.max = 0;
      acc1.index = 1;
      biglietto.AccessoriInfo.push(acc1);
      let acc2 = new AccessorioInfo();
      acc2.descrIt = 'Carrello Elettrico';
      acc2.prezzo = resp.partenza.PrezzoCarrelloElettrico;
      acc2.qta = 0;
      acc2.type = 2;
      acc2.isObb = false;
      acc2.max = 0;
      acc2.index = 1;
      biglietto.AccessoriInfo.push(acc2);
      let acc4 = new AccessorioInfo();
      acc4.descrIt = 'Sacca';
      acc4.prezzo = resp.partenza.PrezzoSacca;
      acc4.qta = 0;
      acc4.type = 2;
      acc4.isObb = false;
      acc4.max = 0;
      acc4.index = 1;
      biglietto.AccessoriInfo.push(acc4);

      biglietto.Partecipanti.push(new Partecipante([]));
      biglietto.Partecipanti[0].name = this.app.curruser.name;
      biglietto.Partecipanti[0].surname = this.app.curruser.surname;
      biglietto.Partecipanti[0].email = this.app.curruser.email;
      biglietto.Partecipanti[0].mobile = this.app.curruser.mobile;

      let error = '';
      const jsonCart = localStorage.getItem(this.app.store + '-cart');
      let cart: Biglietto[] = [];
      if (jsonCart && jsonCart.indexOf('[') >= 0) {
        cart = JSON.parse(jsonCart);
        cart.forEach(b => {
          let dataB = b.DataBiglietto; // DateTime.fromISO(b.DataBiglietto);
          if (b.ParentID === -10 && dataB.startOf('day').toMillis() != biglietto.DataBiglietto.startOf('day').toMillis()) {
            error = 'Non puoi prenotare più ingressi per giorni diversi.';
            return;
          }
        });

        /* cart.forEach((bi) => {
          if (bi.DataBiglietto) {
            bi.DataBiglietto = DateTime.fromISO(bi.DataBiglietto);
            if (bi.DataBiglietto.year !== this.giorno.year || bi.DataBiglietto.month !== this.giorno.month || bi.DataBiglietto.day !== this.giorno.day) {
              error = 'Puoi prenotare gli ingressi e gli ombrelloni solo per lo stesso giorno.';
              return;
            }
          }
        }); */
      } else {
        cart = [];
      }

      if (error) {
        this.app.onMessage.emit(new crossMsg('ShowError', {
          message: error,
        }));
        return;
      }

      /*
      cart.push(biglietto);
      localStorage.setItem(this.app.store + '-cart', JSON.stringify(cart));
      this.settings.setCartItems(cart);
      this.cart = cart;
*/
      await this.app.onMessage.emit(new crossMsg('addToCart', {
        store: this.app.store,
        biglietto: biglietto,
        gotoCart: true
      }));

      //this.router.navigate(['/carrello'], { queryParams: { store: this.app.store } });

      // Creo il biglietto
      /* this.partenza = resp.partenza;
      this.disp = resp.disp;
      this.dispGolfcar = resp.dispGolfcar;
      this.dispCarrelli = resp.dispCarrelli;
      this.dispCarrelliEl = resp.dispCarrelliEl;
      this.dispSacche = resp.dispSacche;
      this.req.partenzaId = this.partenza.IDPartenza;
      this.req.percorsoId = this.partenza.IDPercorso;
      this.req.nome1 = this.auth.currUser.name + ' ' + this.auth.currUser.surname;
      this.req.email1 = this.auth.currUser.email;
      // this.hcp1 = this.auth.currUser.email;
      this.req.telefono = this.auth.currUser.mobile;

      this.gotoPage(1); */

      //this.router.navigateByUrl('/carrello?store=' + this.app.store);

    } else {

    }
  }

  public gotoLogin(): void {
    // this.router.navigateByUrl('/my-account?store=' + this.app.store);
    this.app.onMessage.emit(new crossMsg('gotoUrl', {
      url: 'my-account',
      qstring: 'store=' + this.app.store
    })
    );
  }

  public gotoSocioPage(): void {
    // this.router.navigateByUrl('/richiesta-socio-golf?store=' + this.app.store);
    this.app.onMessage.emit(new crossMsg('gotoUrl', {
      url: 'my-account',
      qstring: 'store=' + this.app.store
    }));
  }

  async invia() {
    this.errorMessage = '';
    this.checkForm();

    if (this.errorMessage === '') {
      const req = new SendFormReq();
      req.store = this.app.store;
      req.responseCaptcha = this.captcha;
      req.emailModel = 'prenota-teetime';
      req.emailModel2 = 'richiesta-inoltrata';
      req.lang = 'it';
      req.fields = [];
      req.fields.push(new drOption(this.prenotaNome, 'Nome'));
      req.fields.push(new drOption(this.prenotaEmail, 'Email'));
      req.fields.push(new drOption(this.prenotaMobile, 'Cellulare'));
      req.fields.push(new drOption(this.prenotaData, 'Data'));
      req.fields.push(new drOption(this.prenotaOra, 'Fascia oraria'));
      req.fields.push(new drOption(this.prenotaPosti, 'Numero di Posti'));
      req.fields.push(new drOption(this.prenotaMsg, 'Messaggio'));

      const resp = await this.cpService.sendForm(AppSettings.API_ENDPOINT, req);
      if (resp.error === '') {
        this.richiestaInviata = true;
        this.prenotaNome = '';
        this.prenotaEmail = '';
        this.prenotaMobile = '';
        this.prenotaMsg = '';
        this.prenotaData = '';
        this.prenotaOra = '';
        this.prenotaPosti = '';
        this.privacy = false;
        this.errorMessage = '';
        this.captcha = '';
        this.captchaElem.reset();
        this.app.onMessage.emit(new crossMsg('ShowToastMessage', {
          message: 'Messaggio inviato con successo!',
        }));
      }


    }
  }

  public checkForm() {
    if (this.prenotaNome === '')
      this.errorMessage = 'Inserisci il tuo nome';
    else if (this.prenotaEmail === '')
      this.errorMessage = 'Inserisci la tua email';
    else if (this.prenotaData === '')
      this.errorMessage = 'Inserisci la data';
    else if (this.prenotaOra === '')
      this.errorMessage = 'Inserisci l\'orario';
    else if (this.prenotaPosti === '')
      this.errorMessage = 'Inserisci il numero di posti';
    else if (this.prenotaMobile === '')
      this.errorMessage = 'Inserisci il tuo numero di cellulare';
    else if (this.privacy === false)
      this.errorMessage = 'Devi accettare le condizioni';
    else if (this.captcha === '')
      this.errorMessage = 'Spunta il re-captcha';
    else
      this.errorMessage = '';
  }

  openUrl(url: string) {
    let link = '';
    if (!url) {
      url = 'https://opengolf.it/it/privacy-policy?header=no';
    }
    if (url.startsWith('http'))
      link = url;
    else
      link = AppSettings.URL + '/img/' + this.app.store + '/' + url;

    const dialogRef = this.dialog.open(PrivacyComponent, {
      data: {
        privacyUrl: link
      },
      panelClass: 'full-screen'
    });

  }
}
